<div>
  <div class="sm:flex sm:items-center justify-between">
    <div class="sm:flex-auto">
      <h1 class="text-xl font-semibold text-gray-900">Closed Users with Remaining Balance</h1>
      <p class="mt-2 text-xs text-gray-700">A list of all closed user accounts holding remaining funds.</p>
    </div>

    <!-- Search Input -->
    <div class="flex items-center gap-4 mt-4 sm:mt-0">
      <div class="relative">
        <input
          type="text"
          placeholder="Search email, name, phone..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchInput($event)"
          class="block w-64 rounded-md border border-gray-300 pl-3 pr-10 py-2 text-xs focus:border-indigo-500 focus:ring-indigo-500"
        />
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="mt-8 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="overflow-hidden shadow md:rounded-lg">
          <table class="min-w-full divide-y divide-gray-300">
            <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">First name</th>
                <th scope="col" class="py-3.5 px-3 text-left text-xs font-semibold text-gray-900">Last name</th>
                <th scope="col" class="py-3.5 px-3 text-left text-xs font-semibold text-gray-900">Email</th>
                <th scope="col" class="py-3.5 px-3 text-left text-xs font-semibold text-gray-900">Phone</th>
                <th scope="col" class="py-3.5 px-3 text-left text-xs font-semibold text-gray-900">Balance</th>
                <th scope="col" class="py-3.5 px-3 text-left text-xs font-semibold text-gray-900">Provider</th>
                <th scope="col" class="py-3.5 px-3 text-left text-xs font-semibold text-gray-900">Closed at</th>
                <th scope="col" class="py-3.5 px-3 text-left text-xs font-semibold text-gray-900">Reason</th>
                <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr *ngFor="let user of closedUsers">
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ user.first_name || '—' }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs font-medium text-gray-900">{{ user.last_name || '—' }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">{{ user.email }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">
                  <span *ngIf="user.phone_number">{{ user.phone_number_prefix ? '+' + user.phone_number_prefix + ' ' : '' }}{{ user.phone_number }}</span>
                  <span *ngIf="!user.phone_number" class="text-gray-400">—</span>
                </td>
                <td class="whitespace-nowrap px-3 py-4 text-xs font-medium text-gray-900">{{ formatAmount(user.balance) }} {{ user.currency || 'USDC' }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">{{ user.wallet_provider || '—' }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">
                  <span *ngIf="user.closed_at">{{ user.closed_at | date: 'dd/MM/yyyy' }}</span>
                  <span *ngIf="!user.closed_at" class="text-gray-400">—</span>
                </td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">{{ user.closure_reason || 'CLOSED' }}</td>
                <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-xs font-medium sm:pr-6">
                  <a
                    [routerLink]="['/dashboard/users', user.uuid, 'information']"
                    class="text-indigo-600 hover:text-indigo-900"
                  >
                    Details
                  </a>
                </td>
              </tr>
              <tr *ngIf="isLoading || closedUsers.length === 0">
                <td colspan="9" class="py-6 text-center text-xs text-gray-500">
                  <ng-container *ngIf="isLoading; else empty">
                    <div class="flex justify-center items-center gap-2">
                      <div class="w-5 h-5 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                      <span>Loading data...</span>
                    </div>
                  </ng-container>
                  <ng-template #empty>
                    Sorry, we couldn't find any results.
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="mt-8 flex justify-center">
          <nav class="inline-flex shadow-sm rounded-md">
            <button
              (click)="goToPreviousPage()"
              [disabled]="!previousPageUrl || isLoading"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-l-md hover:bg-gray-50 disabled:opacity-50"
            >
              ‹
            </button>
            <button
              *ngFor="let page of pageNumbers"
              (click)="page !== '...' && goToPage(page)"
              [disabled]="page === '...' || currentPage === page || isLoading"
              [ngClass]="{
                'bg-indigo-500 text-white': currentPage === page,
                'bg-white text-gray-700': currentPage !== page && page !== '...'
              }"
              class="px-4 py-2 border border-gray-300 text-xs"
            >
              {{ page }}
            </button>
            <button
              (click)="goToNextPage()"
              [disabled]="!nextPageUrl || isLoading"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-r-md hover:bg-gray-50 disabled:opacity-50"
            >
              ›
            </button>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
